import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-number', {
	mixins: [FormElementMixin],
}, 'form/controls/ak-number.html');